import { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Box } from '@theme-ui/components';

import captureError from '@app/helpers/sentry';
import { rem } from '@app/styles/theme/layout';
import { APP_BASE_URL } from '@config/common.config';

import GenericError, {
  GenericErrorMessage,
  GenericErrorTitle,
} from '../GenericError/GenericError';
import messages from './ErrorBoundary.messages';

class ErrorBoundary extends Component<{ children?: React.ReactNode }, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError = (): State => ({ hasError: true });

  componentDidCatch({ message, stack }: Error): void {
    captureError({
      stack,
      message,
      name: 'App Crashed',
      tags: [{ name: 'error_type', value: 'fatalError' }],
    });
  }

  render() {
    return this.state.hasError ? (
      <Box
        sx={{ maxWidth: rem(650), width: '100%' }}
        my={[30, 40]}
        px={[20, 0]}
        mx="auto"
        data-testid="error-boundary-generic-error"
      >
        <GenericError>
          <GenericErrorTitle>
            <FormattedMessage {...messages.headline} />
          </GenericErrorTitle>
          <GenericErrorMessage>
            <FormattedMessage
              {...messages.message}
              values={{
                homepageCta: (
                  <a href={APP_BASE_URL}>
                    <FormattedMessage {...messages.homepageCta} />
                  </a>
                ),
              }}
            />
          </GenericErrorMessage>
        </GenericError>
      </Box>
    ) : (
      this.props.children
    );
  }
}

export default ErrorBoundary;

interface State {
  hasError: boolean;
}
